export const translateNumbersToLowercaseLetters = (input?: string) =>
  input
    ?.toString()
    ?.toLowerCase()
    ?.replace(/[0-9]/g, (x) => "abcdefghij"[x])
    ?.replace(/[^a-z]/g, "");
